module.exports = __webpack_public_path__ + "img/banner-enablesi-pc.d9459f03.png";